import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'ant-design-vue/dist/reset.css'
import '@/assets/styles/global.scss'
import '@/assets/styles/admin.scss'
import App from './App.vue'
import router from './router'
import { permission } from '@/directives/permission'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.directive('permission', permission)
app.mount('#app')
